import { useIntl } from "react-intl";

const AnonymousAccess = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.anonymous-access.title",
            defaultMessage: "Anonymous access"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.unlimited-project-boards.body",
            defaultMessage:
                "Anonymous access makes your Confluence site publicly available, enabling access to your content to users outside of your organization. Confluence's anonymous access is most commonly used for customer-facing knowledge bases and documentation."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default AnonymousAccess;
